import { Injectable } from '@angular/core';
import { DistributorItemDto } from '@common/generated-api/models/distributor-item-dto';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageHelperService {
  distributorCreated$ = new Subject<DistributorItemDto>();

  constructor() {}
}
